export const isSessionStorageEnabled = () => {
  return typeof window !== 'undefined' && navigator?.cookieEnabled;
};
